import * as THREE from 'three';

/** Extra drop below a caster's foot its shadow may still fall to (slopes, cliff edges). */
const DROP = 4;
/** Longest shadow followed, in metres, for a sun near the horizon. */
const LONGEST = 120;

/**
 * Whether something can show on screen, itself or by its shadow: inside the camera's frustum, or with the shadow it throws
 * reaching into it. The sun's shadow camera is far larger than that (it runs hundreds of metres toward the sun so nothing
 * between can lose its shadow), so testing against it posed and drew figures and scenery whose shadows land off screen.
 * The swept test takes the box from where it stands to where its top's shadow meets the ground below it.
 */
export class ShadowReach {
  private frustum = new THREE.Frustum();
  private matrix = new THREE.Matrix4();
  private light = new THREE.Vector3(); private casting = false;
  private swept = new THREE.Box3(); private moved = new THREE.Box3(); private body = new THREE.Box3(); private from = new THREE.Vector3(); private to = new THREE.Vector3();

  update(camera: THREE.Camera, sun?: THREE.DirectionalLight | null) {
    camera.updateMatrixWorld();
    this.frustum.setFromProjectionMatrix(this.matrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
    this.casting = !!sun?.castShadow;
    if (sun && this.casting) {
      sun.updateWorldMatrix(true, false); sun.target.updateWorldMatrix(true, false);
      this.light.setFromMatrixPosition(sun.target.matrixWorld).sub(this.from.setFromMatrixPosition(sun.matrixWorld)).normalize();
    }
  }

  /** `box` in world space. */
  box(box: THREE.Box3) {
    if (this.frustum.intersectsBox(box)) return true;
    if (!this.casting) return false;
    const fall = box.max.y - box.min.y + DROP, length = this.light.y < -1e-3 ? Math.min(LONGEST, fall / -this.light.y) : LONGEST;
    this.moved.copy(box).translate(this.to.copy(this.light).multiplyScalar(length));
    return this.frustum.intersectsBox(this.swept.copy(box).union(this.moved));
  }

  /** A figure standing at `position`, `height` tall, reaching `radius` beyond its body. */
  figure(position: { x: number; y: number; z: number }, height: number, radius: number) {
    this.body.min.set(position.x - radius, position.y - radius, position.z - radius);
    this.body.max.set(position.x + radius, position.y + height + radius, position.z + radius);
    return this.box(this.body);
  }
}
